/**
 * instance模块接口列表
 */
import $http from "../utils/http"; // 导入http中创建的axios实例

const instance = {
  // 创建实例
  createInstance(params) {
    return $http.post(`${global.API_URL}/sme/instance/create`, params);
  },
  //实例列表分页
  pageInstance(params) {
    return $http.post(`${global.API_URL}/sme/instance/page`, params);
  },
  //实例删除
  deleteInstance(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/instance/delete`, param);
  },
  // 根据AccountId查询Instance列表
  queryInstanceByAccountId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstanceByAccountId`,
      params
    );
  },
  // 根据group查询Instance列表
  queryInstanceByGroup(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstanceByGroup`,
      params
    );
  },
  // 根据id查询eip列表
  queryEipById(params) {
    return $http.post(`${global.API_URL}/sme/eip/queryEipById`, params);
  },
  // 下载Excel文件
  exportInstanceTask(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/exportInstanceTask`,
      params,
      {
        responseType: "arraybuffer",
        timeout: 1000 * 60 * 5
      }
    );
  },
  // 根据私有IP查询实例
  queryInstancesByPrivateIP(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstancesByPrivateIP`,
      params
    );
  },
  // 查询定时任务下所有实例
  queryInstancesByScheduleId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstancesByScheduleId`,
      params
    );
  },
  // 根据私有IP查询实例
  queryAWSInstancesByPrivateIP(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryAWSInstancesByPrivateIP`,
      params
    );
  },
  // 根据私有IP查询定时任务
  queryTimedTaskByPrivateIP(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryTimedTaskByPrivateIP`,
      params
    );
  },
  //查询当前组下所有实例
  selectQueryInstancesByGroupId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstancesByGroupId`,
      params
    );
  },
  //查询应用下所有实例
  selectQueryInstancesByApplicationId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstancesByApplicationId`,
      params
    );
  },
  // 通过instanceId查询实例
  queryInstancesByInstanceId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstancesByInstanceId`,
      params
    );
  },
  // 通过instance Name查询实例
  queryPatchInstanceByInstanceId(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryPatchInstanceByInstanceId`,
      params
    );
  },
  //通过查询实例
  selectInstanceField(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/selectInstanceField`,
      params
    );
  },
  //通过查询实例
  queryInstanceByfield(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstanceByfield`,
      params
    );
  },
  // 根据group查询Instance列表
  queryInstanceByGroupMSP(params) {
    return $http.post(
      `${global.API_URL}/sme/instance/queryInstanceByGroupMSP`,
      params
    );
  }
};

export default instance;



// WEBPACK FOOTER //
// ./src/api/instance.js